import React from 'react';

const About = () => {
    return (
        <div>
            <h1 className='text-center lg:text-4xl text-2xl  text-yellow-400 mt-16'>This page is in processing.</h1>
        </div>
    );
};

export default About;